export default __webpack_public_path__ + "static/media/feather.f0819d48.png";